import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

export const ChipsTailwindThemes = {
  chips: {
    root: ({ props }: PrimeReactStylesFunctionType) => ({
      className: classNames('flex', {
        'opacity-60 select-none pointer-events-none cursor-default': props.disabled,
      }),
    }),
    container: ({ state }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'm-0 p-0.75 list-none cursor-text overflow-hidden flex items-center flex-wrap gap-1.75',
        'w-full',
        'bg-white border border-fletchers-gray-100 rounded-sm',
        'transition-colors duration-200 appearance-none',
        'hover:border-fletchers-gray-200',
        { 'outline-none outline-offset-0 border-fletchers-gray-200': state.focused },
      ),
    }),
    inputToken: {
      className: classNames('py-0.5 pr-1 first-of-type:pl-1', 'flex flex-1 inline-flex'),
    },
    input: {
      className: classNames(
        'font-sans text-sm text-black m-0',
        'border-0 outline-none bg-transparent shadow-none rounded-none w-full',
      ),
    },
    token: {
      className: classNames(
        'cursor-default inline-flex items-center',
        'py-0.75 px-1.75 text-xs text-fletchers-green-500',
        'border border-fletchers-green-500 rounded-sm bg-white',
        'hover:bg-fletchers-gray-50',
      ),
    },
    removeTokenIcon: 'ml-1 cursor-pointer',
  },
};
